import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import FormField from 'components/forms/FormField'
import InputSearch from 'suitTheme/InputSearch'
import Link from 'suitTheme/Link'
import SidebarModal from 'modals/sidebar/SidebarModal'
import UserProfileImage from 'suitTheme/UserProfileImage'

const mapResults = (campaignComparables) => {
  const results = {
    groups: [
      {
        key: 'comparables',
        title: 'COMPARABLES',
        items: campaignComparables
          .map(comparable => ({
            ...comparable,
            iconLeft: (
              <UserProfileImage image={{ default: comparable.default_image }} imageKey="default">
                <FontAwesomeIcon icon={faImages} />
              </UserProfileImage>
            ),
            secondaryText: comparable.suburb_name,
            text: comparable.address,
            key: `CampaignComparable-${comparable.id}`,
          })),
      },
    ],
  }

  return results
}

const CampaignComparable = (props) => {
  const {
    imageSelectPayload: {
      callbacks: { selectEntity },
      selectedEntity,
    },
  } = props

  const { address, default_image, suburb_name } = selectedEntity

  const campaignComparables = useSelector(reduxState => Object.values(reduxState.entities.campaignComparables))

  return (
    <>
      <FormField direction="column" label="Search Comparables">
        <InputSearch
          callbacks={{ selectItem: item => selectEntity({ type: 'CampaignComparable', id: item.id }) }}
          closeOnSelect
          placeholder="Search by name"
          results={mapResults(campaignComparables)}
          showOnFocus
        />
      </FormField>

      {!!selectedEntity.id && (
        <SidebarModal.Campaign
          boxProps={{ borderBottom: '1px dashed', borderColor: 'lineColor' }}
          disableHover
          imageUrl={default_image}
          subtitle={suburb_name}
          title={address}
        >
          <Link
            greyLink
            onClick={() => selectEntity({ type: 'CampaignComparable', id: 0 })}
            textProps={{ fontSize: 'small' }}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </Link>
        </SidebarModal.Campaign>
      )}
    </>
  )
}

CampaignComparable.propTypes = {
  imageSelectPayload: PropTypes.shape({
    callbacks: PropTypes.shape({
      selectEntity: PropTypes.func.isRequired,
    }).isRequired,
    images: PropTypes.object.isRequired,
    selectedEntity: PropTypes.object.isRequired,
  }).isRequired,
}

export default CampaignComparable
